"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var http_service_1 = require("./http.service");
var find_http_error_1 = require("../error/find-http-error");
var Subject_1 = require("rxjs/Subject");
var SimCardService = /** @class */ (function () {
    function SimCardService(_httpService) {
        this._httpService = _httpService;
        this.BY_ICC_AND_NOT_ASSOCIATED = SimCardService.SIM_CARD_END_POINT + "/findByContainningIccidAndNotAssociated";
        this.AVAILABLE_SIM_CARDS_BY_ICCID = SimCardService.SIM_CARD_END_POINT + "/findAvailableSimCardsWithAccessByIccidContains";
        this.findSubject = new Subject_1.Subject();
        this.find$ = this.findSubject.asObservable();
        this.errorSubject = new Subject_1.Subject();
        this.error$ = this.errorSubject.asObservable();
    }
    SimCardService.prototype.findByContainningIccidAndNotAssociated = function (iccid) {
        this.getSimCardsByIccid(iccid, this.BY_ICC_AND_NOT_ASSOCIATED);
    };
    SimCardService.prototype.findAvailableSimCardsWithAccessByIccidContains = function (iccid) {
        this.getSimCardsByIccid(iccid, this.AVAILABLE_SIM_CARDS_BY_ICCID);
    };
    SimCardService.prototype.getSimCardsByIccid = function (iccid, url) {
        var _this = this;
        this._httpService.get(url + "/" + iccid, Array, find_http_error_1.FindHttpError)
            .subscribe(function (simCards) { return _this.findSubject.next(simCards); }, function (error) { return _this.errorSubject.next(error); });
    };
    SimCardService.ctorParameters = function () { return [{ type: http_service_1.HttpService }]; };
    SimCardService.SIM_CARD_END_POINT = '/simCard';
    return SimCardService;
}());
exports.SimCardService = SimCardService;
//# sourceMappingURL=sim-card.service.js.map


// WEBPACK FOOTER //
// sim-card.service.js